import { useEffect, useState, useRef } from 'react';

export const useExitIntent = () => {
  const [hasInteracted, setHasInteracted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const timeOnSite = useRef(Date.now());
  const modalShown = useRef(false);

  useEffect(() => {
    // Rastrear interações do usuário
    const interactionEvents = ['mousedown', 'scroll', 'touchstart', 'keydown'];
    
    const handleInteraction = () => {
      setHasInteracted(true);
    };

    interactionEvents.forEach(event => {
      window.addEventListener(event, handleInteraction, { once: true, passive: true });
    });

    // Detectar quando o mouse sai da janela (sinal de que está saindo)
    const handleMouseLeave = (e: MouseEvent) => {
      // Só mostra se o mouse estiver saindo pelo topo (sinal que está indo para a barra de navegação)
      // e se ainda não mostrou o modal
      if (e.clientY <= 0 && !hasInteracted && !modalShown.current) {
        const timeSpent = Date.now() - timeOnSite.current;
        // Só mostra se estiver no site há pelo menos 3 segundos
        if (timeSpent > 3000) {
          setShowModal(true);
          modalShown.current = true;
        }
      }
    };

    // Fallback com beforeunload para navegadores que suportam
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (!hasInteracted && !modalShown.current) {
        const timeSpent = Date.now() - timeOnSite.current;
        if (timeSpent > 3000) {
          // Para navegadores modernos, antes de sair tenta mostrar algo
          // Nota: antes de beforeunload não conseguimos mostrar modal customizado,
          // mas podemos tentar mostrar se ainda não foi mostrado
          e.preventDefault();
          e.returnValue = '';
        }
      }
    };

    // Detectar quando o mouse está saindo pela parte superior
    const handleMouseOut = (e: MouseEvent) => {
      if (!e.relatedTarget && e.clientY <= 0 && !hasInteracted && !modalShown.current) {
        const timeSpent = Date.now() - timeOnSite.current;
        if (timeSpent > 3000) {
          setShowModal(true);
          modalShown.current = true;
        }
      }
    };

    document.addEventListener('mouseleave', handleMouseLeave);
    document.addEventListener('mouseout', handleMouseOut);
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
      document.removeEventListener('mouseout', handleMouseOut);
      window.removeEventListener('beforeunload', handleBeforeUnload);
      interactionEvents.forEach(event => {
        window.removeEventListener(event, handleInteraction);
      });
    };
  }, [hasInteracted]);

  return { showModal, setShowModal };
};
